module.exports = __webpack_public_path__ + "img/hz-logo.81df2958.png";